import { Injectable, Injector } from '@angular/core';
import { AppContext, AppContextManager, FrameContext, onFrameComponentInit } from '@farris/devkit';
import { from, Observable, of } from 'rxjs';
import { BefRepository, BefRepositoryUtil } from '@farris/bef';
import { concatMap, throwIfEmpty } from 'rxjs/operators';
import { ValidationService } from '../validation.service';
import { WorkFlow } from './types';
import { WorkFlowMessage } from './work-flow-message';
import { WorkFlowMessageService } from './work-flow-message.service';

@Injectable()
export class WorkFlowMessageHandler implements onFrameComponentInit {
  constructor(private injector: Injector, private frameContext: FrameContext, private workFlowMessageService: WorkFlowMessageService, private workFlowMessage: WorkFlowMessage) {

  }
  public onComponentInit(frameContext: FrameContext) {
    if (frameContext && !frameContext.isRootFrameContext()) {
      return;
    }
    const eventId = this.workFlowMessage.addEventListener(this.handle.bind(this));
    const frameContextDestroySignal = this.frameContext.destorySignal;
    if (frameContextDestroySignal) {
      frameContextDestroySignal.subscribe(() => {
        this.workFlowMessage.removeEventListener(eventId);
      });
    }
    const appContextDestroySignal = this.frameContext.appContext.destorySignal;
    if (appContextDestroySignal) {
      appContextDestroySignal.subscribe(() => {
        this.workFlowMessage.workFlowMessageService.destroy();
      });
    }
  }
  public handle(message: WorkFlow.IMessage): void {
    const source = message.sender as Window;
    const data = message.data as WorkFlow.IMessageBody;
    const commandName = data && data.command || null;
    let resultTask: Observable<any> = null;
    if (!commandName) {
      return;
    }
    if (commandName == 'wf-required-verification') {
      // å·¥ä½æµçå¿å¡«æ ¡éª
      // å¦æ­¤è·åçæ¯å½åç»ä»¶çæ ¡éªæå¡ï¼åºè¯¥ænamespaceæ¥åºåï¼ä¸åçnamespaceéè¦åå«æ§è¡æ ¡éª
      const formFrameContexts = this.getFormFrameContexts();
      resultTask = from(formFrameContexts).pipe(
        concatMap((frameContext: FrameContext) => {
          const validation = frameContext.injector.get<ValidationService>(ValidationService, null);
          if (validation) {
            return validation.validateCurrentRow();
          }
          return of(true);
        })
      );
    } else {
      const command = this.frameContext.viewModel[commandName];
      // MetadataUtil.getPropsMetadatas(command);
      if (command) {
        const args: any[] = data.arguments;
        const paramValues = args && args.filter((item: any) => item.value !== null);
        const options: any = {};
        if (paramValues && paramValues.length > 0) {
          const params = {};
          paramValues.forEach((item: { code: string, value: string }) => {
            params[item.code] = item.value;
          });
          options.params = params;
        }
        resultTask = command(data.arguments, options);
      }
    }
    if (resultTask) {
      const message: WorkFlow.IMessage = this.buildMessage(true, source, this.isChanged);
      resultTask.pipe(throwIfEmpty()).subscribe((result) => {
        // åæ¥æºæ¹åä¼ æ¶æ¯
        this.workFlowMessageService.send(message);
      }, () => {
        message.data.result = false;
        this.workFlowMessageService.send(message);
      });
    }
  }
  private buildMessage(result: boolean, target: any, dataChanged: boolean, type: string = 'message') {
    const message: WorkFlow.IMessage = {
      data: {
        result,
        dataChanged
      },
      type: type,
      target: target,
    };
    return message;
  }
  private getFormFrameContexts(): FrameContext[] {
    const appContextManager = this.injector.get<AppContextManager>(AppContextManager, null);
    const formFrameContexts = [];
    if (appContextManager) {
      const appContexts: AppContext[] = appContextManager.getAppContexts();
      if (appContexts && appContexts.length > 0) {
        appContexts.forEach((appContext: AppContext) => {
          const frameContexts: FrameContext[] = appContext.frameContextManager.getFrameContexts();
          frameContexts.reduce((contexts: FrameContext[], frameContext: FrameContext) => {
            const namespace = frameContext.namespace;
            const index = contexts.findIndex((frame: FrameContext) => frame.namespace === namespace);
            if (index === -1) {
              const root = frameContext.getVirtualRootFrameContext();
              contexts.push(root);
            }
            return contexts;
          }, formFrameContexts);
        });
      }
    }
    return formFrameContexts;
  }
  /**
   * æ¯å¦ææªä¿å­çåæ´
   */
  private get isChanged(): boolean {
    const befRepository = this.frameContext.repository as BefRepository<any>;
    return BefRepositoryUtil.isExistUnsaveData(befRepository);
  }
}
